import { Commands } from '../../../UI/Command';
var SendV5 = (function () {
    function SendV5(mySender, myAction, myReceiverId, myServerEvent, myArgs, myCallback, myHighPriority) {
        this.mySender = mySender;
        this.myAction = myAction;
        this.myReceiverId = myReceiverId;
        this.myServerEvent = myServerEvent;
        this.myArgs = myArgs;
        this.myCallback = myCallback;
        this.myHighPriority = myHighPriority;
        this.myHighPriority = myHighPriority ? myHighPriority : false;
    }
    Object.defineProperty(SendV5.prototype, "name", {
        get: function () {
            return Commands.SendCommand;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendV5.prototype, "sender", {
        get: function () {
            return this.mySender;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendV5.prototype, "receiverId", {
        get: function () {
            return this.myReceiverId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendV5.prototype, "action", {
        get: function () {
            return this.myAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendV5.prototype, "serverEvent", {
        get: function () {
            return this.myServerEvent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendV5.prototype, "args", {
        get: function () {
            return this.myArgs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendV5.prototype, "callback", {
        get: function () {
            return this.myCallback;
        },
        set: function (value) {
            this.myCallback = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendV5.prototype, "highPriority", {
        get: function () {
            return this.myHighPriority;
        },
        enumerable: false,
        configurable: true
    });
    return SendV5;
}());
export { SendV5 };
